import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";

const Tnc = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  const handleAccept = async () => {
    if (!checked) return; // Require checkbox
    const userRef = doc(db, "users", user.uid);
    await updateDoc(userRef, { tncAccepted: true });

    setUser({ ...user, tncAccepted: true });
    navigate("/portal/home", { replace: true });
  };
  return (
    <div
      style={{
        maxWidth: "80%",
        margin: "100px auto",
        padding: "40px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
        Terms & Conditions
      </h1>

      <div
        style={{
          maxHeight: "400px",
          overflowY: "scroll",
          padding: "15px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          marginBottom: "20px",
          lineHeight: "1.6",
        }}
      >
        <p>
          Welcome to the Tabl Portal. By accessing or using this portal, you
          agree to comply with and be bound by the following terms and
          conditions:
        </p>
        <h3>1. Acceptance of Terms</h3>
        <p>
          By logging in and using this portal, you acknowledge that you have
          read, understood, and agree to these Terms & Conditions. If you do not
          agree, you must not access or use the portal.
        </p>
        <h3>2. Eligibility</h3>
        <p>
          Access to the portal is granted only to authorized users, including
          clients, employees, or partners, who have valid login credentials.
          Sharing credentials with unauthorized persons is strictly prohibited.
        </p>
        <h3>3. User Responsibilities</h3>
        <p>
          You are responsible for maintaining the confidentiality of your login
          credentials. You must not misuse the portal or access data without
          proper authorization. You agree not to engage in any activity that may
          disrupt the portal or compromise its security.
        </p>
        <h3>4. Data Privacy</h3>
        <p>
          Any personal or organizational data entered or accessed through this
          portal will be used solely for legitimate business purposes. Your data
          will be handled in accordance with Tabl’s Privacy Policy.
        </p>
        <h3>5. Intellectual Property</h3>
        <p>
          All content, software, and resources on this portal are the property
          of Tabl or its licensors. You may not copy, reproduce, or distribute
          any material without prior written consent.
        </p>
        <h3>6. Prohibited Conduct</h3>
        <p>
          You agree not to attempt to gain unauthorized access to the portal,
          introduce viruses or malware, or share/distribute portal content
          without permission.
        </p>
        <h3>7. Limitation of Liability</h3>
        <p>
          Tabl is not responsible for any direct or indirect loss arising from
          the use or inability to use the portal. Users access the portal at
          their own risk.
        </p>
        <h3>8. Termination</h3>
        <p>
          Tabl reserves the right to suspend or terminate access for any user
          who violates these terms, without prior notice.
        </p>
        <h3>9. Changes to Terms</h3>
        <p>
          We may update these Terms & Conditions from time to time. Users will
          be notified of any material changes. Continued use constitutes
          acceptance.
        </p>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label>
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ marginRight: "10px" }}
          />
          I have read and agree to the Terms & Conditions
        </label>
      </div>

      <button
        onClick={handleAccept}
        disabled={!checked}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "6px",
          border: "none",
          backgroundColor: checked ? "#1976d2" : "#ccc",
          color: "white",
          cursor: checked ? "pointer" : "not-allowed",
        }}
      >
        I Accept
      </button>
    </div>
  );
};

export default Tnc;
